export default __webpack_public_path__ + "static/media/invite-friends-icon.0a1c5ae5.png";